import { render, staticRenderFns } from "./CircRnaQueryRnaInfomation.vue?vue&type=template&id=e96b30b6&scoped=true"
import script from "./CircRnaQueryRnaInfomation.vue?vue&type=script&lang=js"
export * from "./CircRnaQueryRnaInfomation.vue?vue&type=script&lang=js"
import style0 from "./CircRnaQueryRnaInfomation.vue?vue&type=style&index=0&id=e96b30b6&prod&scoped=true&lang=css"
import style1 from "./CircRnaQueryRnaInfomation.vue?vue&type=style&index=1&id=e96b30b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96b30b6",
  null
  
)

export default component.exports